module.exports = __webpack_public_path__ + "static/img/股权激励_方案版.a305100.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/股权激励_方案版.jpg
// module id = ZSqE
// module chunks = 1